export type NavIcon =
  | 'mapPin'
  | 'target'
  | 'penLine'
  | 'share'
  | 'mail'
  | 'phone'
  | 'bot'
  | 'messages'
  | 'star'
  | 'monitor'
  | 'zap'
  | 'layout'
  | 'users'
  | 'info'

export type NavSubItem = {
  name: string
  description: string
  href: string
  icon: NavIcon
}

export type NavItem = {
  name: string
  href: string
  route?: 'pricing' | 'contact' | 'industries' | 'crm'
  children?: NavSubItem[]
  mega?: 'marketing' | 'design' | 'company'
}

// Mega menu groupings for the Marketing dropdown (desktop). Item names must match marketingServices.
export const marketingGroups: { title: string; items: string[] }[] = [
  { title: 'Get Found', items: ['Local SEO', 'Lead Generation — PPC', 'Content Creation'] },
  { title: 'Stay Top of Mind', items: ['Social Media Marketing', 'Email Marketing', 'Reputation Management'] },
  { title: 'Never Miss a Lead', items: ['Advanced Phone System', 'AI Phone Attendant', 'AI Support'] },
]

export const marketingMenuFeature = {
  image: 'https://cdn.magicpatterns.com/uploads/bFwPotEiUH11PrZDHLUZww/LasVegasMarketingCompany.jpg',
  kicker: 'Free 60-minute session',
  title: 'Get a marketing plan built for your business',
  cta: 'Book my strategy session',
  href: '#/contact',
}

export const marketingServices: NavSubItem[] = [
  { name: 'Local SEO', description: 'Rank on Google Maps & local search', href: '#/marketing/local-seo', icon: 'mapPin' },
  { name: 'Lead Generation — PPC', description: 'Google & Meta ads that convert', href: '#/marketing/ppc', icon: 'target' },
  { name: 'Content Creation', description: 'Blogs, video & copy that sells', href: '#/marketing/content', icon: 'penLine' },
  { name: 'Social Media Marketing', description: 'Consistent posts & engagement', href: '#/marketing/social', icon: 'share' },
  { name: 'Email Marketing', description: 'Nurture sequences & broadcasts', href: '#/marketing/email', icon: 'mail' },
  { name: 'Advanced Phone System', description: 'Calls, texting & call tracking', href: '#/marketing/phone-system', icon: 'phone' },
  { name: 'AI Phone Attendant', description: 'Answers every call, 24/7', href: '#/marketing/ai-phone', icon: 'bot' },
  { name: 'AI Support', description: 'Chat & automatic lead follow-up', href: '#/marketing/ai-support', icon: 'messages' },
  { name: 'Reputation Management', description: 'More 5-star reviews, on autopilot', href: '#/marketing/reputation', icon: 'star' },
]

export const designServices: NavSubItem[] = [
  { name: 'Website Design', description: 'Websites that update in minutes', href: '#/design/websites', icon: 'monitor' },
  { name: 'Our Work', description: 'Real sites we have built', href: '#/design/gallery', icon: 'layout' },
]

// Company dropdown (desktop panel + mobile menu both read this list).
export const companyLinks: NavSubItem[] = [
  // ABOUT US: future spot. Do NOT add until David supplies the About content.
  // When ready: add a route in hooks/useHashRoute.ts + App.tsx, then uncomment the line below.
  // { name: 'About Us', description: 'Who we are and how we work', href: '#/about', icon: 'info' },
  { name: 'Partner Center', description: 'Sell our websites, marketing and plans. Get paid monthly.', href: '#/partners', icon: 'users' },
  { name: 'Contact Us', description: 'Talk to a real person in Las Vegas', href: '#/contact', icon: 'phone' },
]

export const navItems: NavItem[] = [
  { name: 'Marketing', href: '#/marketing', children: marketingServices, mega: 'marketing' },
  { name: 'Web Design', href: '#/design', children: designServices, mega: 'design' },
  { name: 'CRM', href: '#/crm', route: 'crm' },
  { name: 'Pricing', href: '#/pricing', route: 'pricing' },
  { name: 'Industries', href: '#/industries', route: 'industries' },
  { name: 'Company', href: '#/partners', children: companyLinks, mega: 'company' },
]
